import React from 'react';
import { Tag as AntdTag, type TagProps as AntdTagProps } from 'antd';

export type TagProps = AntdTagProps;

type TagComponent = React.ForwardRefExoticComponent<
    TagProps & React.RefAttributes<HTMLSpanElement>
> & {
    CheckableTag: typeof AntdTag.CheckableTag;
};

const Tag = React.forwardRef<HTMLSpanElement, TagProps>((props, ref) => (
    <AntdTag ref={ref} {...props} />
)) as TagComponent;

Tag.displayName = 'Tag';
Tag.CheckableTag = (AntdTag as typeof AntdTag | undefined)
    ?.CheckableTag as typeof AntdTag.CheckableTag;

export { AntdTag };
export default Tag;
